import CommonConstants from '@/common/CommonConstants'
import CACA1130ResponseModel from '@/api/data/CAC/CACA1130/CACA1130ResponseModel'
import { Component, Vue } from 'vue-property-decorator'
import CACG1130Service from './CACG1130Service'
import CACG1130ViewModel from './CACG1130ViewModel'
import CACG1110ParamModel from '../CACG1110/CACG1110ParamModel'
import CACG1120ParamModel from '../CACG1120/CACG1120ParamModel'
import TransportService from '@/common/TransportService'
import CommonUtil from '@/common/utils/CommonUtil'
import { fixedContent } from '@/assets/js/main.js'
import { nextTick } from 'process'
@Component({
  name: 'CACG1130',
  components: {}
  })
export default class CACG1130Controller extends Vue {
  private isCompleteLoading = false
  private SCALE_VALUE = 15
  private DEFAULT_YEAR_SELECTED = 0
  private cacg1130ViewModel: CACG1130ViewModel = {
    productNameInformal: '',
    creditingRateTenYearLst: [
      {
        rateYears: '',
        creditingRate: null
      }
    ],
    productDivName: '',
    productDiv2: '',
    typeProduct: null,
    transOfProduct: '',
    dataChart: [],
    productNo: '',
    shhnCd: '',
    yearText: '1年'
  }

  private caca1130ResponseModel: CACA1130ResponseModel =
    new CACA1130ResponseModel()

  private cacg1130Service: CACG1130Service = new CACG1130Service()

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    nextTick(() => {
      fixedContent()
    })
    if (this.cacg1130ViewModel.dataChart?.length > 0) {
      window.addEventListener('orientationchange', this.refreshPage);
    }
  }

  beforeDestroy() {
    window.removeEventListener('orientationchange', this.refreshPage);
  }

  private refreshPage() {
    location.reload();
  }

  /**
   * 初期処理
   */
  private async init() {
    const productNo = JSON.parse(
      JSON.stringify(this.$route.query.productNo || '')
    )
    const shhnCd = JSON.parse(JSON.stringify(this.$route.query.shhnCd || ''))

    this.cacg1130ViewModel.productNo = productNo
    this.cacg1130ViewModel.shhnCd = shhnCd
    const [
      caca1130ResponseModelResponse,
      transportResponseModel
    ] = await Promise.all([
      this.cacg1130Service.callAPICACA1130(
        productNo,
        shhnCd
      ),
      // 稼働／閲覧統計ログを実行する
      TransportService.callAPITransportWithLogMode(CommonConstants.URL_CACG1130, null, `shhnCd=${shhnCd}`, CommonConstants.LOG_MODE_ACCESS_ONLY)
    ])
    this.caca1130ResponseModel = caca1130ResponseModelResponse;

    this.cacg1130ViewModel.productNameInformal =
      this.caca1130ResponseModel.productNameInformal

    if (
      this.caca1130ResponseModel.creditingRateTenYearLst &&
      CommonUtil.isNotNullArray(
        this.caca1130ResponseModel.creditingRateTenYearLst,
        ['creditingRate']
      )
    ) {
      this.cacg1130ViewModel.creditingRateTenYearLst =
        this.caca1130ResponseModel.creditingRateTenYearLst

      this.cacg1130ViewModel.dataChart = this.cacg1130Service.createDataChart(
        this.cacg1130ViewModel.creditingRateTenYearLst.reverse()
      )
    } else {
      this.cacg1130ViewModel.creditingRateTenYearLst = null
    }

    this.cacg1130ViewModel.productDivName =
      this.caca1130ResponseModel.productDivName
    this.cacg1130ViewModel.productDiv2 = this.caca1130ResponseModel.productDiv2

    if (
      this.caca1130ResponseModel.productDiv2 === CommonConstants.INSURANCE_VALUE
    ) {
      this.cacg1130ViewModel.typeProduct = '保証利率'
      this.cacg1130ViewModel.transOfProduct = '保証利率の推移'
    } else if (
      this.caca1130ResponseModel.productDiv2 === CommonConstants.DEPOSIT_VALUE
    ) {
      this.cacg1130ViewModel.typeProduct = '適用利率'
      this.cacg1130ViewModel.transOfProduct = '適用利率の推移'
    }

    this.isCompleteLoading = true
  }

  /**
   * 「運用商品詳細（元本確保型）：適用金利」（CACG1110）画面に遷移する。
   */
  private gotoCACG1110() {
    const cacg1110ParamModel: CACG1110ParamModel = {
      productNo: this.cacg1130ViewModel.productNo,
      shhnCd: this.cacg1130ViewModel.shhnCd
    }
    this.$router.push({ name: 'cacg1110', query: cacg1110ParamModel })
  }

  /**
   * 「運用商品詳細（元本確保型）：資料一覧」（CACG1120）画面に遷移する。
   */
  private gotoCACG1120() {
    const cacg1120ParamModel: CACG1120ParamModel = {
      productNo: this.cacg1130ViewModel.productNo,
      shhnCd: this.cacg1130ViewModel.shhnCd
    }
    this.$router.push({ name: 'cacg1120', query: cacg1120ParamModel })
  }

  /**
   *運用商品一覧（CACG1010）画面に遷移する。
   */
  private gotoCACG1010() {
    this.$router.push({ name: 'cacg1010' })
  }

  /**
   * 資産残高の推移ボタン押下
   * @param yearNum
   */
  public async clickChangeYear(yearNum) {
    this.cacg1130ViewModel.yearText = yearNum + '年'
  }
}
